import * as tslib_1 from "tslib";
import * as React from 'react';
import TaskSummaryCard from './TaskSummaryCard';
import TaskRelativesPopover from './TaskRelatives';
import { formatDigits } from 'src/utils/numbers';
import { inject, observer } from 'mobx-react';
import { LinearProgress } from 'material-ui';
var styles = {
    container: {
        padding: '0 .5rem',
        display: 'grid',
        gridGap: '3px',
        gridTemplateColumns: '1fr 1fr 1fr auto'
    },
    progress: {
        marginTop: '10px',
        padding: '0px',
        backgroundColor: 'white',
        borderRadius: '0px'
    }
};
var TaskProgress = /** @class */ (function (_super) {
    tslib_1.__extends(TaskProgress, _super);
    function TaskProgress(props) {
        return _super.call(this, props) || this;
    }
    TaskProgress.prototype.render = function () {
        var _a = this.props, task = _a.task, color = _a.color, preferencesStore = _a.preferencesStore;
        if (!preferencesStore.cardProgressVisible.value) {
            return null;
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { style: styles.container },
                React.createElement(TaskSummaryCard, { title: "Elt\u00F6lt\u00F6tt id\u0151", text: formatDigits(task.sumDuration) + " \u00F3ra", color: color }),
                React.createElement(TaskSummaryCard, { title: "Tervezett id\u0151", text: formatDigits(task.plannedDuration) + " \u00F3ra", color: color }),
                React.createElement(TaskSummaryCard, { title: "K\u00E9sz\u00FClts\u00E9g", text: formatDigits(task.percentage) + " %", color: color }),
                React.createElement(TaskRelativesPopover, { relatives: task.relatives })),
            React.createElement(LinearProgress, { style: styles.progress, color: color, mode: "determinate", min: 0, max: 100, value: task.progress })));
    };
    TaskProgress = tslib_1.__decorate([
        inject('preferencesStore'),
        observer
    ], TaskProgress);
    return TaskProgress;
}(React.Component));
export default TaskProgress;



//////////////////
// WEBPACK FOOTER
// ./src/pages/tasks/TaskProgress.tsx
// module id = 777
// module chunks = 0